<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>mdi-view-carousel</v-icon>
        <span class="m-l-5">Carousel</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>

    <div class="container">
      <div class="box-type">
        <v-radio-group v-model="prompt.isManual" row hide-details>
          <v-radio
            v-for="(type, indexType) in carouselTypes"
            :key="indexType"
            :label="type"
            :value="type === carouselTypes[0]"
          >
          </v-radio>
        </v-radio-group>
      </div>
      <div v-if="prompt.isManual" class="container-carousel">
        <div
          v-for="(payload, index) in prompt.payloads"
          :key="index"
          class="card-carousel-item"
        >
          <div class="box-delete">
            <v-icon
              v-if="prompt.payloads.length > minCarousel"
              small
              @click="deletePayload(index)"
            >
              fa-times-circle
            </v-icon>
          </div>
          <div>
            <div
              v-if="previewUrls[index] && previewUrls[index].url"
              class="box-preview-image text-center"
            >
              <div class="box-delete-image">
                <v-icon small @click="deleteImage(index)">
                  fa-times-circle
                </v-icon>
              </div>
              <img :src="previewUrls[index].url" height="170" />
            </div>
            <div v-else>
              <span class="title-image">Image</span>
              <v-autocomplete
                class="no-drag"
                v-model="payload.image"
                :items="items"
                item-text="allText"
                item-value="path"
                dense
                hide-details
                @change="changePreviewImage(index, payload.image)"
              >
                <template slot="selection" slot-scope="{ item }">
                  {{ subString(item.path, 70) }}
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-tooltip top :open-delay="700">
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        class="float-right width100 font-size-sub margin8px m-r-5"
                      >
                        <div class="dropdown-text">
                          {{ subString(item.description, 70) }}
                        </div>
                        <div class="dropdown-title">
                          {{ subString(item.name, 50) }}
                        </div>
                      </div>
                    </template>
                    <span class="font-size-body">
                      {{ item.path }}<br />{{ item.description }}
                    </span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </div>
          </div>
          <div class="box-text">
            <div>
              <v-text-field
                label="URL landing page (on click image)"
                placeholder=""
                v-model="payload.urlLanding"
                class="m-t-20 m-b-10"
                dense
                hide-details
              >
              </v-text-field>
            </div>
            <div>
              <input
                type="text"
                class="input-carousel-title page-rename"
                :id="`title-${index}`"
                :value="payload.title"
                @blur="renameTitle(index, true)"
                @keyup.enter="renameTitle(index, true)"
                @keyup.esc="renameTitle(index, false)"
              />
            </div>
            <div>
              <input
                type="text"
                class="input-carousel-subtitle page-rename"
                :id="`subtitle-${index}`"
                :value="payload.subtitle"
                @blur="renameSubtitle(index, true)"
                @keyup.enter="renameSubtitle(index, true)"
                @keyup.esc="renameSubtitle(index, false)"
              />
            </div>
          </div>
          <div
            v-for="(button, indexButton) in payload.buttons"
            :key="indexButton"
          >
            <div class="box-button">
              <div class="box-button-left">
                <div class="box-button-left-inside">
                  <div class="label-button-type">Button type</div>
                  <v-radio-group v-model="button.type" row hide-details>
                    <v-radio
                      v-for="(type, indexButtonType) in buttonTypes"
                      :key="indexButtonType"
                      :label="type"
                      :value="type"
                    >
                    </v-radio>
                  </v-radio-group>
                  <v-text-field
                    id="button-text-title"
                    :label="
                      button.type === buttonTypes[0]
                        ? 'Message'
                        : button.type === buttonTypes[1] ||
                          button.type === buttonTypes[2]
                        ? 'Label'
                        : 'Title'
                    "
                    :placeholder="
                      button.type === buttonTypes[0]
                        ? 'Message'
                        : button.type === buttonTypes[1] ||
                          button.type === buttonTypes[2]
                        ? 'Label'
                        : 'Title'
                    "
                    v-model="button.title"
                    class="button-text-field"
                    dense
                    hide-details
                  >
                  </v-text-field>
                  <v-text-field
                    v-if="button.type !== buttonTypes[0]"
                    id="button-text-title"
                    :label="button.type === buttonTypes[2] ? 'URL' : 'Payload'"
                    :placeholder="
                      button.type === buttonTypes[2]
                        ? 'http://www.example.com'
                        : 'Payload'
                    "
                    v-model="button.payload"
                    class="button-text-field"
                    dense
                    hide-details
                  >
                  </v-text-field>
                </div>
              </div>
              <div
                v-if="payload.buttons.length > minButton"
                class="box-button-delete"
              >
                <v-icon small @click="deleteButton(index, indexButton)">
                  fa-times-circle
                </v-icon>
              </div>
            </div>
          </div>
          <div
            v-if="payload.buttons.length < maxButton"
            class="box-button-add"
            @click="addButton(index)"
          >
            <v-icon class="outline m-l-5">fa-plus-square</v-icon>
          </div>
        </div>
        <div
          v-if="prompt.payloads.length < maxCarousel"
          class="card-carousel-item-add"
          @click="addPayload()"
        >
          <div class="box-carousel-add">
            <v-icon class="outline m-l-5">fa-plus-square</v-icon>
          </div>
        </div>
      </div>
      <div v-else class="p-l-10 p-r-10">
        <v-row class="p-t-5 p-b-0">
          <v-col cols="5" class="p-t-0">
            For each object in
          </v-col>
          <v-col cols="7" class="p-t-0">
            <v-text-field
              class="m-auto shift-m-t"
              v-model="prompt.variable.apiResult"
              label="Array variable"
              placeholder="${ApiName.data.results}"
              hint="For example, ${api.data.*}"
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          v-model="prompt.variable.image"
          label="Image variable"
          placeholder="${current.image}"
          hide-details
          class="m-t-0"
        ></v-text-field>
        <v-text-field
          v-model="prompt.variable.urlLanding"
          label="URL landing page variable (on click image)"
          placeholder="${current.url}"
          hide-details
          class="m-t-20"
        >
        </v-text-field>
        <v-text-field
          v-model="prompt.variable.title"
          label="Title variable"
          placeholder="${current.title}"
          hide-details
          class="m-t-20"
        ></v-text-field>
        <v-text-field
          v-model="prompt.variable.subtitle"
          label="Subtitle variable"
          placeholder="${current.subtitle}"
          hide-details
          class="m-t-20 p-b-5"
        ></v-text-field>
        <div class="box-variable-button">
          <div class="label-button-type">Button type</div>
          <v-radio-group
            v-model="variableButtonType"
            @change="changeVariableButtonType"
            row
            hide-details
          >
            <v-radio
              v-for="(varButtonType, indexButtonType) in varButtonTypes"
              :key="indexButtonType"
              :label="varButtonType"
              :value="varButtonType"
            >
            </v-radio>
          </v-radio-group>
          <v-text-field
            id="button-text-title"
            :label="
              prompt.variable.button.type === varButtonTypes[0]
                ? 'Message'
                : 'Label'
            "
            :placeholder="
              prompt.variable.button.type === varButtonTypes[0]
                ? '${current.message}'
                : '${current.label}'
            "
            v-model="prompt.variable.button.title"
            class="button-text-field"
            dense
            hide-details
          >
          </v-text-field>
          <v-text-field
            v-if="prompt.variable.button.type !== varButtonTypes[0]"
            id="button-text-title"
            label="URL"
            placeholder="${current.url}"
            v-model="prompt.variable.button.payload"
            class="button-text-field"
            dense
            hide-details
          >
          </v-text-field>
          <!--<v-text-field
            v-if="prompt.variable.button.type !== varButtonTypes[0]"
            id="button-text-title"
            :label="
              prompt.variable.button.type === varButtonTypes[2] ? 'URL' : 'Payload'
            "
            :placeholder="
              prompt.variable.button.type === varButtonTypes[2]
                ? '${current.url}'
                : '${current.payload}'
            "
            v-model="prompt.variable.button.payload"
            class="button-text-field"
            dense
            hide-details
          >
          </v-text-field>-->
        </div>
        <div>
          <span class="title-image">Default image (more carousel)</span>
          <v-autocomplete
            class="no-drag"
            v-model="prompt.variable.defaultImage"
            :items="items"
            item-text="allText"
            item-value="path"
            dense
            hide-details
          >
            <template slot="selection" slot-scope="{ item }">
              {{ subString(item.path, 70) }}
            </template>
            <template slot="item" slot-scope="{ item }">
              <v-tooltip top :open-delay="700">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    class="float-right width100 font-size-sub margin8px m-r-5"
                  >
                    <div class="dropdown-text">
                      {{ subString(item.description, 70) }}
                    </div>
                    <div class="dropdown-title">
                      {{ subString(item.name, 50) }}
                    </div>
                  </div>
                </template>
                <span class="font-size-body">
                  {{ item.path }}<br />{{ item.description }}
                </span>
              </v-tooltip>
            </template>
          </v-autocomplete>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import apiFlow from '@/apis/flow'
export default {
  name: 'PayloadCarousel',
  props: {
    index: Number,
    prompt: Object,
    minioHost: String,
    items: Array
  },
  data() {
    return {
      payloads: [],
      previewUrls: [],
      minCarousel: 1,
      maxCarousel: 5,
      minButton: 1,
      maxButton: 3,
      buttonType: 1,
      buttonTypes: ['text', 'postback', 'web'],
      varButtonTypes: ['text', 'web'],
      carouselTypes: ['Manual', 'Loop from API result'],
      variableButtonType: 'text'
    }
  },
  watch: {
    prompt: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.prompt.isManual) {
          if (this.prompt.payloads.length < this.minCarousel) this.addPayload()
          if (this.prompt.payloads.length >= this.minCarousel)
            this.getSecureUrl()
        } else {
          if (this.prompt.variable === undefined)
            this.prompt.variable = this.getVariableInitialData()
        }
      }
    }
  },
  created() {
    this.initial()
  },
  methods: {
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    },

    subString(text, length) {
      if (text.length < length) return text
      return `${text.substr(0, length)}...`
    },

    async initial() {
      if (this.prompt.isManual === undefined) this.prompt.isManual = true

      if (this.prompt.variable === undefined)
        this.prompt.variable = this.getVariableInitialData()
      else this.variableButtonType = this.prompt.variable.button.type

      if (this.prompt.isManual) {
        if (this.prompt.payloads.length < this.minCarousel) this.addPayload()
        if (this.prompt.payloads.length >= this.minCarousel) this.getSecureUrl()
      }
    },

    getSecureUrl() {
      this.prompt.payloads.forEach((item, index) => {
        if (item.image) {
          this.changePreviewImage(index, item.image)
        }
      })
    },

    async changePreviewImage(index, path) {
      if (path) {
        const result = await apiFlow.getSecureUrl(path)
        if (result.data) {
          await this.setPreviewUrl(index, result.data)
        }
      }
    },

    setPreviewUrl(index, url) {
      const payloadLength = this.prompt.payloads.length
      const previewLength = this.previewUrls.length
      if (previewLength === payloadLength) {
        this.updatePreviewUrl(index, url)
      } else {
        if (previewLength < index) {
          for (let i = 0; i < payloadLength; i++) {
            if (i === index) this.previewUrls.push({ index, url })
            else this.previewUrls.push({ index: i, url: '' })
          }
        } else if (payloadLength > previewLength)
          this.previewUrls.push({ index: previewLength, url: '' })
        else this.previewUrls.push({ index, url })

        if (previewLength === payloadLength) {
          this.previewUrls = _.sortBy(this.previewUrls, [item => item.index])
        }
      }
    },

    updatePreviewUrl(index, url) {
      this.previewUrls = this.previewUrls.map((item, i) => ({
        ...item,
        url: index === i ? url : item.url
      }))
    },

    deleteImage(index) {
      this.deleteImageUrl(index)
      this.updatePreviewUrl(index, '')
    },

    deleteImageUrl(index) {
      this.prompt.payloads[index].image = ''
    },

    getButtonInitialData() {
      return {
        type: this.buttonTypes[0],
        title: '',
        payload: '',
        label: 'label'
      }
    },

    getPayloadInitialData() {
      return {
        buttons: [],
        image: '',
        urlLanding: '',
        title: 'Click to edit title',
        subtitle: 'Click to edit subtitle',
        preview: ''
      }
    },

    getVariableInitialData() {
      return {
        apiResult: '',
        defaultImage: '',
        image: '',
        urlLanding: '',
        title: '',
        subtitle: '',
        button: this.getButtonInitialData()
      }
    },

    addPayload() {
      this.prompt.payloads.push(this.getPayloadInitialData())
      this.addButton(this.prompt.payloads.length - 1)
    },

    deletePayload(index) {
      this.prompt.payloads.splice(index, 1)
      this.previewUrls.splice(index, 1)
    },

    addButton(index) {
      const data = this.getButtonInitialData()
      this.prompt.payloads[index].buttons.push(data)
    },

    deleteButton(index, indexButton) {
      this.prompt.payloads[index].buttons.splice(indexButton, 1)
    },

    renameTitle(index, isSave) {
      const div = document.getElementById(`title-${index}`)
      let newText = div.value
      const oldText = this.prompt.payloads[index].title
      if (!isSave) newText = oldText
      this.prompt.payloads[index].title = newText
      if (div) div.blur()
    },

    renameSubtitle(index, isSave) {
      const div = document.getElementById(`subtitle-${index}`)
      let newText = div.value
      const oldText = this.prompt.payloads[index].subtitle
      if (!isSave) newText = oldText
      this.prompt.payloads[index].subtitle = newText
      if (div) div.blur()
    },

    changeVariableButtonType(value) {
      this.prompt.variable.button.type = value
      this.variableButtonType = value
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-messages__message {
  font-size: 10px;
}

.font-size-body {
  max-width: 300px;
  display: flex;
  text-align: justify;
  text-justify: inter-word;
  padding-left: 4px;
  margin-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  word-wrap: break-word;
}

.width20px {
  min-width: 20px;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.dropdown-title {
  font-size: 14px;
}

.dropdown-text {
  font-size: 11px;
  color: $text-color;
}

.margin8px {
  margin: 8px 0;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.container {
  padding: 5px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.container-carousel {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.box-delete {
  display: flex;
  justify-content: right;
}

.card-carousel-item {
  display: inline-block;
  vertical-align: top;
  width: 365px;
  margin: 5px;
  padding: 5px 10px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.card-carousel-item-add {
  display: inline-block;
  vertical-align: top;
  width: 365px;
  margin: 5px;
  padding: 30px 0;
  background-color: #fff;
  border: 1px dashed #ebebeb;
  border-radius: 5px;
}

.box-carousel-add {
  display: flex;
  justify-content: center;
}

.title-image {
  font-size: 10px;
}

.box-preview-image {
  margin-top: 5px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.box-delete-image {
  display: flex;
  justify-content: right;
}

.box-text {
  margin: 10px 0 5px 0;
}

.input-carousel-title {
  width: 100%;
  font-weight: bold;
  font-size: 16px;
}

.input-carousel-subtitle {
  width: 100%;
}

.box-button {
  margin: 5px 0px;
  display: flex;
  border-radius: 2px;
  border: 1px solid #ebebeb;
}

.box-button-left {
  padding: 10px 0px;
  width: 95%;
  display: flex;
  // justify-content: center;
}

.box-button-left-inside {
  width: 100%;
  padding-left: 10px;
}

.label-button-type {
  font-size: 11px;
}

.input-button-title {
  color: #8196b8;
  width: 80%;
  text-align: center;
}

.button-text-field {
  width: 100%;
  margin-top: 20px;
}

.box-button-add {
  margin: 5px 0px;
  padding: 10px 0px;
  border-radius: 2px;
  border: 1px dashed #ebebeb;
  display: flex;
  justify-content: center;
}

.box-button-delete {
  width: 5%;
  margin-left: 5px;
  display: flex;
  justify-content: center;
}

.box-type {
  margin: 10px;
}

.box-variable-button {
  margin: 5px 0px;
  padding: 10px;
  border-radius: 2px;
  border: 1px solid #ebebeb;
}
</style>
